import { IAppState } from '../../redux';

export function selectIsAuctionOpen(state: IAppState): boolean {
  const {
    auction: { isOpen },
  } = state;

  return isOpen;
}
